import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { fetchPlanById, searchPlans } from "../store/user/actions";
import { useLocation, useParams } from "react-router-dom";
import { RootState } from "../store/root-reducer";
import { isScopeLoading } from "../store/scope-loading/helpers";
import { UserScope } from "../store/user/types";
import Loader from "../components/Loader";
import LinkNotValid from "../components/LinkNotValid";
import queryString from "query-string";

function Warrntyid({ loading, plans }) {
  const dispatch = useDispatch();
  const { warrnty_id } = useParams();
  const { search = "" } = useLocation();
  const parsedQuery = queryString.parse(search, {
    parseBooleans: true,
  });
  useEffect(() => {
    if (warrnty_id && dispatch) {
      dispatch(
        searchPlans({
          search_type: "search_plan_5",
          warrnty_id,
          redirectExternal: true,
        })
      );
    }
    return () => {};
  }, [dispatch, parsedQuery, warrnty_id]);

  if (loading) return <Loader isLoading={loading} />;
  if (!loading && plans?.length <= 0) return <LinkNotValid />;
  return null;
}

const mapStateToProps = (state: RootState) => ({
  loading: isScopeLoading(state.scopeLoading, UserScope),
  plans: state.user.plans,
});

export default connect(mapStateToProps)(Warrntyid);
